import { type App } from 'vue';
import { registerPartial } from '@precon-tools-suite-by-shared/vue-partials';

// Export the helpers that you want to use outside of this library.
export type { MaybeOwnedPredicate } from './components/PredicateSelect.vue';

export { default as ExpressionBuilder } from './components/ExpressionBuilder.vue';

// The definition of the plugin that installs the
export default {
    install(app: App) {
        registerPartial(
            app,
            '@precon-tools-suite-by-shared/gino-predicates-feature/partials/AnswerProductPredicates',
            () => import('./partials/AnswerProductPredicates.vue')
        );
    },
};
